import { Middleware } from '@reduxjs/toolkit';

import { safeLocalStorage } from '../../../../helpers/utils/safeStorage';
import { QUERY_NAME_DASHBOARD } from '../../../../shared/common/constants/query-params';

/**
 * Redux middleware для синхронизации состояния с localStorage/sessionStorage.
 * Выполняет сохранение ПОСЛЕ обновления state (вызов next(action) происходит первым).
 */
export const localStorageSyncMiddleware: Middleware = () => (next) => (action) => {
    const result = next(action);

    switch (action.type) {
        case 'period/setPeriod': {
            if (!action.payload?.blockId) {
                safeLocalStorage.setItem(
                    'current_un_period',
                    JSON.stringify(action.payload)
                );
            }
            break;
        }
        case 'attr/setAttributes': {
            if (action.payload) {
                safeLocalStorage.setItem(
                    'attr_state',
                    JSON.stringify(action.payload)
                );
            }
            break;
        }
        case 'filter/setCurrentSegment': {
            safeLocalStorage.setItem(
                'current_segment',
                JSON.stringify(action.payload)
            );
            break;
        }
        case 'reports/setMainDashboard': {
            safeLocalStorage.setItem(QUERY_NAME_DASHBOARD, action.payload);
            break;
        }
        case 'reports/clearReportState': {
            try {
                sessionStorage.removeItem('dashboard_hash');
                sessionStorage.removeItem('dashboard_id');
            } catch (_) {
                // Safari Private Mode
            }
            break;
        }
    }

    return result;
};
